/**
 * 2~4차 전직 가능 여부·분기. Phaser 없음.
 * 레벨은 ADVANCEMENT, 분기는 jobs.nextIds. 차수 건너뛰기는 거부한다.
 */

import { ADVANCEMENT } from '../data/balance';
import { getJob, JOBS, type JobDef } from '../data/jobs';

export interface AdvanceState {
  level: number;
  jobId: string;
}

/** 현재 직업에서 다음 차수로 가려면 필요한 레벨. 4차이거나 분기가 없으면 null. */
export function requiredLevel(jobId: string): number | null {
  const job = getJob(jobId);
  if (job.rank === 1) return ADVANCEMENT.rank2;
  if (job.rank === 2) return ADVANCEMENT.rank3;
  if (job.rank === 3) return ADVANCEMENT.rank4;
  return null;
}

/** 바로 다음 차수 직업만. nextIds 가 더 높은 차수를 가리켜도 버린다. */
export function nextJobOptions(jobId: string): JobDef[] {
  const job = getJob(jobId);
  const want = job.rank + 1;
  const out: JobDef[] = [];
  for (const id of job.nextIds) {
    const next = JOBS[id];
    if (!next || next.rank !== want) continue;
    out.push(next);
  }
  return out;
}

export function canAdvance(state: AdvanceState): boolean {
  const req = requiredLevel(state.jobId);
  if (req === null || state.level < req) return false;
  return nextJobOptions(state.jobId).length > 0;
}
